const white = "#FFFFFF";
const black = "#000000";
//https://material.io/resources/color/#!/?view.left=0&view.right=1&primary.color=00c6e2&secondary.color=f9ae07&primary.text.color=000000

export const primaryColor = "#5386CC";
export const secondaryColor = "#1A2033";

export const warningColor = "#ECC34E";
export const successColor = "#76E5B9";

export const errorColor = "#E15142";

export const tableHeaderColor = "#F4F6F9";

export const backgroundDefaultColor = "#1D1E25";

export const backgroundPrimaryColor = "#1D1E25";
export const backgroundSecondaryColor = "#2A2B39"; // palette.secondary.dark
export const defaultTextColor = "#FAFAFA"; // text.secondary
export const defaultBorderColor = "#33363D";
export const defaultAccentColor = "#5386CC"; // palette.primary.main
export const backgroundTernaryColor = "#33363d"; // palette.secondary.light
export const defaultSelectedPaginationButtonColor = "rgb(83 134 204 / 17%)";

export const iconColor = "#8C92A1";

export const lightPalette = {
  common: {
    black: "#000",
    white: "#fff",
  },
  mode: "light",
  primary: {
    main: "#5386cc",
    contrastText: "#fff",
    light: "#759ed6",
    dark: "#3a5d8e",
  },
  secondary: {
    main: "#1A2033",
    dark: "#e0ebf9",
    contrastText: "#fff",
    light: "#474c5b",
  },
  error: {
    main: "#E15142",
    light: "#e77367",
    dark: "#9d382e",
    contrastText: "#fff",
  },
  warning: {
    main: "#ECC34E",
    light: "#efcf71",
    dark: "#a58836",
    contrastText: "#000000de",
  },
  info: {
    light: "#64b5f6",
    main: "#2196f3",
    dark: "#1976d2",
    contrastText: "#fff",
  },
  success: {
    main: "#76E5B9",
    light: "#91eac7",
    dark: "#52a081",
    contrastText: "#000000de",
  },
  grey: {
    "50": "#fafafa",
    "100": "#f5f5f5",
    "200": "#eeeeee",
    "300": "#e0e0e0",
    "400": "#bdbdbd",
    "500": "#9e9e9e",
    "600": "#757575",
    "700": "#616161",
    "800": "#424242",
    "900": "#212121",
    A100: "#d5d5d5",
    A200: "#aaaaaa",
    A400: "#303030",
    A700: "#616161",
  },
  contrastThreshold: 3,
  tonalOffset: 0.2,
  text: {
    primary: "#1A2033",
    secondary: "#676F86",
    disabled: "#00000061",
    hint: "#00000061",
  },
  divider: "#0000001f",
  background: {
    paper: "#fff",
    default: "#fafafa",
  },
  action: {
    active: "#0000008a",
    hover: "#0000000a",
    hoverOpacity: 0.04,
    selected: "#00000014",
    selectedOpacity: 0.08,
    disabled: "#00000042",
    disabledBackground: "#0000001f",
    disabledOpacity: 0.38,
    focus: "#0000001f",
    focusOpacity: 0.12,
    activatedOpacity: 0.12,
  },
};

export const darkPalette = {
  common: {
    black: "#000",
    white: "#fff",
  },
  mode: "dark",
  primary: {
    main: "#5386cc",
    contrastText: "#fff",
    light: "#759ed6",
    dark: "#3a5d8e",
  },
  secondary: {
    main: "#1A2033",
    dark: "#3a384d",
    contrastText: "#fff",
    light: "#474c5b",
  },
  error: {
    main: "#ff5544",
    light: "#ff7769",
    dark: "#ff5544",
    contrastText: "#fff",
  },
  warning: {
    main: "#ECC34E",
    light: "#efcf71",
    dark: "#ECC34E",
    contrastText: "#000000de",
  },
  info: {
    light: "#64b5f6",
    main: "#2196f3",
    dark: "#1976d2",
    contrastText: "#fff",
  },
  success: {
    main: "#13c880",
    light: "#42d399",
    dark: "#13c880",
    contrastText: "#000000de",
  },
  grey: {
    "50": "#fafafa",
    "100": "#f5f5f5",
    "200": "#eeeeee",
    "300": "#e0e0e0",
    "400": "#bdbdbd",
    "500": "#9e9e9e",
    "600": "#757575",
    "700": "#616161",
    "800": "#424242",
    "900": "#212121",
    A100: "#d5d5d5",
    A200: "#aaaaaa",
    A400: "#303030",
    A700: "#616161",
  },
  contrastThreshold: 3,
  tonalOffset: 0.2,
  text: {
    primary: "#ffffff",
    secondary: "#fafafa",
    disabled: "#00000061",
    hint: "#00000061",
  },
  divider: "rgba(0, 0, 0, 0.12)",
  background: {
    paper: "#2b2a39",
    default: "#1d1e25",
  },
  action: {
    active: "#0000008a",
    hover: "#0000000a",
    hoverOpacity: 0.04,
    selected: "#00000014",
    selectedOpacity: 0.08,
    disabled: "#00000042",
    disabledBackground: "#0000001f",
    disabledOpacity: 0.38,
    focus: "#0000001f",
    focusOpacity: 0.12,
    activatedOpacity: 0.12,
  },
};
